




































import { Component, Vue } from "vue-property-decorator";
import {
  ItemKitDinamico,
  KitsDinamicosService,
} from "@/services/kits-dinamicos.service";
import { required } from "@/shared/validators";
import Modal from '@/shared/components/modal.vue';

@Component({
  components: {
    Modal
  }
})
export default class ItemKitDinamicoForm extends Vue {
  model: {
    idKitDinamico: string;
    descricao: string;
    idItemKitDinamico?: string;
  } | null = null;

  titulo = '';
  loading = false;

  rules = {
    descricaoItem: [required()],
  };

  valid = false;

  async salvarItem() {

    const form = this.$refs.form as any;
    if (form.validate()){
      if (this.model){
        
          this.loading = true;
          try
          {
              if (this.model.idItemKitDinamico) {
                  await KitsDinamicosService.alterarItemKitDinamico({
                      idItemKitDinamico: this.model.idItemKitDinamico,
                      descricao: this.model.descricao
                  });
              } else {
                  await KitsDinamicosService.incluirItemKitDinamico({
                      idKitDinamico: this.model.idKitDinamico,
                      descricao: this.model.descricao
                  });
              }

                this.close(true);

          }
          finally
          {
              this.loading = false;
          }
      }
    }   
  }

  async close(res: boolean) {
    const modal = this.$refs.modal as Modal;
    return modal.close(res);
  }

  async novo(idKitDinamico: string) {
      const modal = this.$refs.modal as Modal;
      this.titulo = 'Novo Kit Dinâmico'

        this.model = {
            idKitDinamico: idKitDinamico,
            descricao: '',
        };

      return modal.open();
  }

  async alterar(item: ItemKitDinamico) {
      const modal = this.$refs.modal as Modal;
      this.titulo = 'Alterar Kit Dinâmico'

       this.model = {
            idKitDinamico: item.kitDinamico?.idKitDinamico!,
            idItemKitDinamico: item.idItemKitDinamico,
            descricao: item.descricao!,
        };

      return modal.open();
  }
}
